<script lang="ts">
	import type { TokenSymbol } from '$lib/types/tokens';
	import { quadInOut } from 'svelte/easing';
	import { fade } from 'svelte/transition';
	import ScTokenDropDownItem from './SCTokenDropDownItem.svelte';

	export let showTokenSelector: boolean = false;
	export let tokensAllowed: Array<TokenSymbol>;
	export let changeToken: (token: TokenSymbol) => void;
</script>

{#if showTokenSelector}
	<div
		class="border border-fx-grey-600 bg-fx-red p-4 z-50 absolute right-10 mt-16 bg-fx-gradient-8 rounded-lg squircle-lg flex flex-col gap-2"
		in:fade={{
			duration: 200,
			delay: 0,
			easing: quadInOut
		}}
	>
		{#each tokensAllowed as token}
			<ScTokenDropDownItem {changeToken} {token} />
		{/each}
	</div>
{/if}
